<template>
  <div class="box-image-area section-space--pt_90" :style="bgImg" id="cursos">
    <div class="container">
      <!-- titulo -->
      <div
        class="
          section-title-wrapper
          text-center
          section-space--mb_60
          wow
          move-up
        "
      >
        <h2 class="section-title mb-30 font-weight-bold text-white">
          Cursos destacados
        </h2>
        <div
          class="
            elementor-element elementor-element-79f9819
            elementor-widget-divider--view-line
            elementor-widget elementor-widget-divider
          "
          data-id="79f9819"
          data-element_type="widget"
          data-widget_type="divider.default"
        >
          <div class="elementor-widget-container">
            <div class="elementor-divider">
              <span class="elementor-divider-separator-white"> </span>
            </div>
          </div>
        </div>
      </div>
      <!-- fin titulo -->
      <!-- cursos component -->
      <div class="row mb-3">
        <div class="col-lg-12">
          <div class="swiper-container team-slider__container">
            <swiper :options="swiperOption">
              <!-- Card -->
              <TarjetaCurso
                v-for="(curso, index) in getCursosFechaMes"
                :key="index"
                :curso="curso"
                class="swiper-slide"
              />
              <!-- End Card -->
            </swiper>
            <div
              class="swiper-pagination swiper-pagination-2 section-space--mt_50"
              v-show="mostrar_paginador"
            ></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex justify-content-center mt-4">
          <a
            href="https://forumapp.progrentis.com/cartelera-cursos"
            class="btn btn-primary"
            >Ver todos</a
          >
        </div>
      </div>
      <!-- fin cursos component -->
    </div>

    <div class="container-fluid">
      <!-- box transparente -->
      <div class="row no-padding">
        <div class="box-transparent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

import TarjetaCurso from "@/components/features/tarjetaCurso";

export default {
  components: { TarjetaCurso },
  methods: {},
  created() {
    this.$apollo.queries.getCursosFechaMes.refetch();
  },
  data() {
    return {
      bgImg: {
        backgroundImage: `linear-gradient(360deg, rgb(255, 170, 1) 10.84%, rgb(255, 86, 1) 70.98%)`,
      },
      getCursosFechaMes: [],
      /**
       * Configuracion carrusel
       */
      mostrar_paginador: false,
      swiperOption: {
        speed: 800,
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1499: {
            slidesPerView: 3,
          },

          991: {
            slidesPerView: 2,
          },

          767: {
            slidesPerView: 1,
          },

          575: {
            slidesPerView: 1,
          },
        },
      },
    };
  },
  apollo: {
    getCursosFechaMes: {
      query: gql`
        query {
          getCursosFechaMes {
            _id
            nombre
            fecha_curso
            precio
            tipo_curso
            img
            formato_curso
            categoria {
              nombre
            }
            estudiantes {
              _id
              nombre
              apellido
            }
          }
        }
      `,
      pollInterval: 120000,
    },
  },
};
</script>

<style lang="scss" scoped>
.no-padding {
  padding: 0;
}
.swiper-pagination{
  position: relative !important;
}

.box-transparent {
  margin-top: 25px;
  background: linear-gradient(transparent 10%, #ffffff);
  width: 100%;
  height: 200px;
}
</style>


